export default __webpack_public_path__ + "static/media/arbitrum.cc0ed7c1.png";